import { render, staticRenderFns } from "./_PrizeList.vue?vue&type=template&id=250f48a4&scoped=true"
import script from "./_PrizeList.vue?vue&type=script&lang=ts"
export * from "./_PrizeList.vue?vue&type=script&lang=ts"
import style0 from "./_PrizeList.vue?vue&type=style&index=0&id=250f48a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f48a4",
  null
  
)

export default component.exports